import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";
import { apiFetch } from "../../utils/api";
import { Link } from "react-router-dom";

const CanchasPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])
  const [error, setError] = useState("")

  const eliminarItem = async (id) => {
    setIsLoading(true);
    setError("");
    try {
      const data = await apiFetch(`/api/courts/${id}`,{
        method: "DELETE",
      });
      if (data.status) {
        setDatos([])
        await cargarDatos();
      } else {
        setError(data.message || "No se pudo eliminar la cancha.");
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error:', error);
      setError(error.message || "No se pudo eliminar la cancha.");
      setIsLoading(false);
    }
  }

  const [datosTabla] = useState({
    titulo: "Canchas",
    ruta: "/cancha",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable,
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "NOMBRE", key: "nombre" },
    { title: "SUCURSAL", key: "branch.nombre" },
    { title: "ACTIVO", key: "activo" },
    { title: "FECHA_ALTA", key: "createdAt", isDate: true },
  ]);

  const cargarDatos = async () => {
    setIsLoading(true);
    setError("");
    try {
      const data = await apiFetch("/api/courts",{
        method: "GET",
      });
      console.log(data);
      if(data.status){
        setDatos(Array.isArray(data.data) ? data.data : []);
      } else {
        setDatos([]);
        setError(data.message || "No se pudieron cargar las canchas.");
      }
    } catch (error) {
      console.error('Error:', error);
      setDatos([]);
      setError(error.message || "No se pudieron cargar las canchas.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : (
        <>
          { error && (
            <div className="alert alert-warning" role="alert">
              {error}
            </div>
          )}
          <div className="d-flex justify-content-end mb-16">
            <Link to="/tarifas-canchas" className="btn btn-primary">
              Configurar tarifas por horario
            </Link>
          </div>
          <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/>
        </>
      )}
      </MasterLayout>
    </>
  );
};

export default CanchasPage;
